<template>
    <div class="pageContent">
        <PageHeader/>
        <div class="pageMain">
            <router-view></router-view>
        </div>
        <PageFooter class="pageFooter-wrap"/>
    </div>
</template>

<script>
import axios from 'axios'
import PageHeader from '../components/PageHeader.vue'
import PageFooter from "../components/PageFooter.vue";
export default {
    name: 'HomePage',
    components: {PageHeader, PageFooter},
    data() {
        return {
            recruitmentUi: {
                verifyMode: 'B',
                loaded: false,
            },
        }
    },
    provide() {
        return {
            recruitmentUi: this.recruitmentUi,
        }
    },
    mounted() {
        axios.get('/zhaopinapi/public/recruitment-verify-mode')
            .then((res) => {
                const d = res.data
                if (d && (d.code === 200 || d.success) && d.data && d.data.verifyMode) {
                    const v = String(d.data.verifyMode).trim().toUpperCase()
                    this.recruitmentUi.verifyMode = v === 'A' ? 'A' : 'B'
                }
            })
            .catch(() => { /* 保持 B */ })
            .finally(() => {
                this.recruitmentUi.loaded = true
            })
    },
}
</script>

<style scoped>
    .pageContent{
        width: 100%;
        min-width: 1150px;
        min-height: 100%;
        display: flex;
        flex-direction: column;
    }
    .pageMain{
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        padding-top: 8px;
    }
    .pageFooter-wrap{
        flex-shrink: 0;
        margin-top: auto;
    }
</style>
